import { render, staticRenderFns } from "./DeclarationINSS.vue?vue&type=template&id=68b56478"
import script from "./DeclarationINSS.vue?vue&type=script&lang=js"
export * from "./DeclarationINSS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports